import videoIcon from "@/assets/images/video-icon.svg";
import videoIconActive from "@/assets/images/video-icon-active.svg";
import audioIcon from "@/assets/images/audio-icon.svg";
import audioIconActive from "@/assets/images/audio-icon-active.svg";
import foodPic from "@/assets/images/food.png"
import fashionPic from "@/assets/images/fashion.png"
import funPic from "@/assets/images/fun.png"
import techPic from "@/assets/images/technology.png"
import playPic from "@/assets/images/play.png"
import holidayPic from "@/assets/images/holiday.png"
export const SourceType = {
    VIDEO: 'VIDEO',
    AUDIO: 'AUDIO'
}
export const videoAndAudioInfo = [
    {
        label: '视频',
        value: SourceType.VIDEO,
        icon: videoIcon,
        activeIcon: videoIconActive
    }, {
        label: "音频",
        value: SourceType.AUDIO,
        icon: audioIcon,
        activeIcon: audioIconActive
    }
]

// 精选专题
export const specialCategory = [
    {
        value: "food",
        label: "美食",
        bgPic: foodPic
    },
    {
        value: "fashion",
        label: "时尚",
        bgPic: fashionPic
    },
    {
        value: "fun",
        label: "欢乐",
        bgPic: funPic
    },
    {
        value: "technology",
        label: "科技",
        bgPic: techPic
    },
    {
        value: "play",
        label: "玩乐",
        bgPic: playPic
    },
    {
        value: "holiday",
        label: "节日",
        bgPic: holidayPic
    },
]

// 分辨率
export const displayFps = [
    {
        value: "-1",
        label: "全部",
    },
    {
        value: '4',
        label: '4k',
    },
    {
        value: "3",
        label: "1080p",
    },
    {
        value: '2',
        label: '720p',
    },
    {
        value: '1',
        label: '720p以下',
    }
]
// 视频时长
export const videoTime = [
    {
        value: '-1',
        label: '全部'
    },
    {
        value: '1',
        label: '30秒以下'
    },
    {
        value: '2',
        label: '30-60秒'
    },
    {
        value: '3',
        label: '1-2分钟'
    },
    {
        value: '4',
        label: '2分钟以上'
    }
]
//音频节拍
export const bpmList = [
    {
        value: '-1',
        label: '全部'
    },
    {
        value: '1',
        label: '非常慢 (0-60 BPM)'
    },
    {
        value: '2',
        label: '缓慢 (60-100 BPM)'
    },
    {
        value: '3',
        label: '适中 (100-120 BPM)'
    },
    {
        value: '4',
        label: '充满活力 (120-140 BPM)'
    },
    {
        value: '5',
        label: '快速 (140-160 BPM)'
    },
    {
        value: '6',
        label: '非常快 (160-400 BPM)'
    }
]

// 资源类型
export const ResourceType = [
    {
        label: '图片',
        value: '1'
    },
    {
        label: '视频',
        value: '2'
    },
    {
        label: '音频',
        value: '3'
    }
]
// 音频价格
export const AudioPriceList = [
    {
        label: '全部',
        value: -1
    },
    {
        label: '价格不高于300',
        value: 1
    },
    {
        label: '价格不高于900',
        value: 2
    },
    {
        label: '价格高于900',
        value: 3
    }
]